import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put, select} from 'redux-saga/effects';
import {getPubPosts} from 'services/posts';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {IPost} from 'typescript/models/Post';

import {setGetPubPostsData, setGetPubPostsStatusAC, IState, setGetPubPostsMeta} from '../postsSlice';
import {getPubPostsACS} from '../requestAC';

export function* getPubPostsSaga(action: ReturnType<typeof getPubPostsACS>) {
  try {
    const reqStatus: IState['getPubPosts']['status'] = yield select((state) => state.posts.getPubPosts.status);

    if (reqStatus === 'success') yield put(setGetPubPostsStatusAC('refetching'));
    else yield put(setGetPubPostsStatusAC('loading'));

    const response: AxiosResponse<ApiData<IPost[]>> = yield call(getPubPosts, action.payload);
    yield put(setGetPubPostsData(response.data.data));
    yield put(setGetPubPostsMeta(response.data.meta));

    yield put(setGetPubPostsStatusAC('success'));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.GET_PUB_POSTS);
    yield put(setGetPubPostsStatusAC('error'));
  }
}
